import React, { useEffect } from 'react'
import SolutionsContent from '../components/Solutions/SolutionsContent';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectLanguage } from '../redux/language/selector';
import NavbarTopSolution from './../components/global/NavbarTopSolution';

const Solutions = () => {
  

  const {t} = useTranslation()

    const language = useSelector(selectLanguage)

    

    useEffect(() => {
        document.title = t('solutions-page.solutions-page-title')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[language])

  return (
    <div>
        <NavbarTopSolution/>
        <SolutionsContent/>
    </div>
  )
}

export default Solutions